import { excludedStatusCodes } from '@omni/kit/utilities/excludedStatusCodes';

import BaseService, { IHttpResponse, IUri } from '../../BaseService';
import { prepareUrl } from '../BuildUrls';
import { IChatSession } from '../Types';

const RESOURCE = 'chat-sessions';

interface ICreateSession extends Omit<IUri, 'resource'> {
  appKey: string;
  token?: string;
}

export const REFRESH_ERROR_MESSAGE =
  'Access token expired, waiting for token to be refreshed..';

export default async function createChatSession({
  appKey,
  token,
  ...buildUrlProps
}: ICreateSession): Promise<IChatSession> {
  if (!token) {
    throw new Error('No access token provided');
  }

  const url = prepareUrl({
    ...buildUrlProps,
    resource: RESOURCE,
  });

  const headers: Record<string, string> = {
    'sap-active-appkey': appKey,
  };

  const response = await BaseService.Post({
    url,
    appKey,
    headers,
    token,
  });

  return handleResponse(response);
}

function handleResponse(response: IHttpResponse): Promise<IChatSession> {
  if (response?.status && response?.status >= 200 && response?.status < 400) {
    return Promise.resolve(response.body);
  }

  if (!response?.status || excludedStatusCodes.includes(response.status)) {
    return Promise.reject(
      new Error(
        `Warning: unable to create a chat session. Status:${response?.status}. Body:${response?.body}`
      )
    );
  }

  return Promise.reject(
    new Error(
      `Error: failed to create a chat-session: Status:${response?.status}. Body:${response?.body}`
    )
  );
}
